const component = "site-sections-tree-appliance-category-filter";

export const siteSectionsTreeApplianceCategoryFilter = {
  component,
  trigger: `${component}/filters/appliance-category/trigger`,
  triggerLabel: `${component}/filters/appliance-category/trigger-label`,
  popover: `${component}/filters/appliance-category/popover`,
  searchInput: `${component}/filters/appliance-category/search-input`,
  option: (category: string): string => `${component}/filters/appliance-category/options/${category}`,
  optionIcon: (category: string): string => `${component}/filters/appliance-category/options/${category}/icon`,
};
